var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c("emd-alert", {
        attrs: { variant: "info", noClose: "", title: _vm.$t("alert") },
      }),
      _c("emd-text", { staticClass: "eu-my_4", attrs: { size: "medium" } }, [
        _c("b", [_vm._v(_vm._s(_vm.$t("title")))]),
      ]),
      _c(
        "text-section",
        [
          _c("emd-text-content", { attrs: { title: _vm.$t("bank") } }, [
            _c(
              "b",
              [
                _c("emd-text", { attrs: { size: "medium" } }, [
                  _vm._v(_vm._s(_vm.values.bank)),
                ]),
              ],
              1
            ),
          ]),
          _c("emd-text-content", { attrs: { title: _vm.$t("type") } }, [
            _c(
              "b",
              [
                _c("emd-text", { attrs: { size: "medium" } }, [
                  _vm._v(_vm._s(_vm.values.type)),
                ]),
              ],
              1
            ),
          ]),
        ],
        1
      ),
      _c(
        "text-section",
        [
          _c(
            "emd-text-content",
            { attrs: { title: _vm.$t("accountNumber") } },
            [
              _c(
                "b",
                [
                  _c("emd-text", { attrs: { size: "medium" } }, [
                    _vm._v(
                      " " +
                        _vm._s(_vm.values.accountNumber) +
                        "-" +
                        _vm._s(_vm.values.accountCheckDigit) +
                        " "
                    ),
                  ]),
                ],
                1
              ),
            ]
          ),
          _c("emd-text-content", { attrs: { title: _vm.$t("branchNumber") } }, [
            _c(
              "b",
              [
                _vm.values.branchCheckDigit
                  ? _c("emd-text", { attrs: { size: "medium" } }, [
                      _vm._v(
                        _vm._s(_vm.values.branchNumber) +
                          "-" +
                          _vm._s(_vm.values.branchCheckDigit) +
                          " "
                      ),
                    ])
                  : _c("emd-text", { attrs: { size: "medium" } }, [
                      _vm._v(_vm._s(_vm.values.branchNumber) + " "),
                    ]),
              ],
              1
            ),
          ]),
          _c(
            "emd-text-content",
            { attrs: { title: _vm.$t("holderDocument") } },
            [
              _c(
                "b",
                [
                  _c("emd-text", { attrs: { size: "medium" } }, [
                    _vm._v(_vm._s(_vm.cpfOrCnpjFormated)),
                  ]),
                ],
                1
              ),
            ]
          ),
        ],
        1
      ),
      _c(
        "text-section",
        [
          _c(
            "emd-text-content",
            { staticClass: "nowrap", attrs: { title: _vm.$t("holderName") } },
            [
              _c(
                "b",
                [
                  _c("emd-text", { attrs: { size: "medium" } }, [
                    _vm._v(_vm._s(_vm.values.holderName)),
                  ]),
                ],
                1
              ),
            ]
          ),
        ],
        1
      ),
      _vm.hasRecipients
        ? _c(
            "text-section",
            [
              _c(
                "emd-text-content",
                { staticClass: "nowrap", attrs: { title: _vm.$t("receiver") } },
                [
                  _c(
                    "b",
                    [
                      _c("emd-text", { attrs: { size: "medium" } }, [
                        _vm._v(_vm._s(_vm.recipientName)),
                      ]),
                    ],
                    1
                  ),
                ]
              ),
            ],
            1
          )
        : _vm._e(),
      _c(
        "text-section",
        [
          _c("emd-text-content", { attrs: { title: _vm.$t("totalAmount") } }, [
            _c(
              "b",
              [
                _c("emd-text", { attrs: { size: "medium" } }, [
                  _vm._v(_vm._s(_vm.values.totalAmount)),
                ]),
              ],
              1
            ),
          ]),
          _c("emd-text-content", { attrs: { title: _vm.$t("amount") } }, [
            _c(
              "b",
              {
                staticClass: "eu-display_flex pointer",
                on: {
                  click: function ($event) {
                    return _vm.$emit("edit")
                  },
                },
              },
              [
                _c(
                  "emd-text",
                  {
                    staticClass: "emd-text edit-text",
                    attrs: { size: "medium" },
                  },
                  [_vm._v(_vm._s(_vm.values.amount) + " ")]
                ),
                _c("emerald-icon", {
                  staticClass: "eu-mx_2",
                  attrs: { icon: "edit" },
                }),
              ],
              1
            ),
          ]),
        ],
        1
      ),
      _c("hr", { staticClass: "eu-my_4" }),
      _c(
        "form",
        {
          on: {
            submit: function ($event) {
              $event.preventDefault()
              return _vm.$emit("submit", _vm.password)
            },
          },
        },
        [
          _c("label", { staticClass: "emd-label _required" }, [
            _vm._v(_vm._s(_vm.$t("passwordConfirmation"))),
          ]),
          _c("emd-input", {
            class: { _state_error: _vm.passwordIncorrect },
            attrs: { name: "password", type: "password" },
            model: {
              value: _vm.password,
              callback: function ($$v) {
                _vm.password = $$v
              },
              expression: "password",
            },
          }),
          _c("b", [
            _vm.passwordIncorrect
              ? _c(
                  "span",
                  { staticClass: "emd-text _size_small error eu-mt_1" },
                  [_vm._v(_vm._s(_vm.$t("passwordIncorrect")))]
                )
              : _vm._e(),
          ]),
          _vm.$slots.default
            ? _c(
                "div",
                { staticClass: "actions eu-mt_5" },
                [_vm._t("default")],
                2
              )
            : _vm._e(),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }